/* eslint-disable no-console */
import {
  all,
  call,
  takeLatest,
  takeEvery,
  takeLeading,
  race,
  take, fork,
} from "redux-saga/effects";
import {
  libraryActionsConstants,
} from "../actions";
import {
  _sharedWorkerFetchAllHistory,
  _sharedWorkerGetIdAndPositionForBookOpen,
  _sharedWorkerSaveAllHistory,
  _sharedWorkerSaveListenHistory,
  _sharedWorkerSaveReadHistory, _sharedWorkerSetLibraryLanguages,
  _sharedWorkerToggleBookInMLById,
} from "@/shared/store/library/saga";

function* getIdAndPositionToBookOpen(action) {
  const {
    bookId,
    isGonnaListen,
    isUseMLHistory, isUseDefaultHistory, isUseLocalHistory,
    isFetchNewestHistory, isPreferNewestHistory,
    onSuccess,
  } = action.data;

  const result = yield _sharedWorkerGetIdAndPositionForBookOpen(
    bookId,
    isGonnaListen,
    isUseMLHistory, isUseDefaultHistory, isUseLocalHistory,
    isFetchNewestHistory,
    isPreferNewestHistory,
  );

  if (onSuccess) {
    onSuccess(result);
  }
}

function* watchRaceGetIdAndPositionToOpenBook() {
  while (true) {
    const action = yield take(libraryActionsConstants.GET_ID_AND_POSITION_TO_OPEN_BOOK);
    yield race({
      task: call(getIdAndPositionToBookOpen, action),
      cancel: take(libraryActionsConstants.CANCEL_GET_ID_AND_POSITION_TO_OPEN_BOOK)
    });
  }
}

export default function* settingsSaga() {
  yield all([
    takeLatest(libraryActionsConstants.ACTION_SAVE_READ, _sharedWorkerSaveReadHistory),
    takeLatest(libraryActionsConstants.ACTION_SAVE_ALL, _sharedWorkerSaveAllHistory),
    takeLeading(libraryActionsConstants.ACTION_SAVE_LISTEN, _sharedWorkerSaveListenHistory),
    takeEvery(libraryActionsConstants.FETCH_ALL_BOOKS_DATA, _sharedWorkerFetchAllHistory),
    takeEvery(libraryActionsConstants.TOGGLE_BOOK_IN_ML_BY_ID, _sharedWorkerToggleBookInMLById),
    takeEvery(libraryActionsConstants.SET_LIBRARY_LANGUAGES, _sharedWorkerSetLibraryLanguages),
    fork(watchRaceGetIdAndPositionToOpenBook),
  ]);
}
